module.exports = __webpack_public_path__ + "static/media/arrowDown.8567985c.svg";